import { Link } from "react-router-dom";
import { PenLine } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// End-of-article card that opens the Journal with a prompt filled in
export const WriteAboutIt = ({ journal }) => {
  const { user } = useAuth();
  const to = (p) => (user?.has_paid ? `/journal?cat=${journal.cat}&prompt=${encodeURIComponent(p)}` : "/pricing");
  return (
    <div className="mm-card p-6 mt-10" data-testid="article-write-about-it">
      <div className="font-bold text-lg flex items-center gap-2"><PenLine size={18} className="text-mm-primary" />Write about it</div>
      <p className="text-sm text-mm-muted mt-1">Putting feelings into words can make them a little lighter. Pick a gentle prompt to start a private journal entry.</p>
      <div className="flex flex-col gap-2 mt-4">
        {journal.prompts.map((p, i) => (
          <Link key={p} to={to(p)} className="mm-soft p-3 text-sm rounded-2xl hover:bg-mm-primary/10 transition-colors" data-testid={`article-journal-prompt-${i}`}>{p}</Link>
        ))}
      </div>
    </div>
  );
};
